import { Type } from "@scalar/typebox";
import { HeaderObjectRef } from "../../../schemas/v3.1/strict/ref-definitions.js";
import { reference } from "./reference.js";
const EncodingObjectSchemaDefinition = Type.Object({
  /** The Content-Type for encoding a specific property. The value is a comma-separated list, each element of which is either a specific media type (e.g. image/png) or a wildcard media type (e.g. image/*). Default value depends on the property type as shown in the table below. */
  contentType: Type.Optional(Type.String()),
  /** A map allowing additional information to be provided as headers. Content-Type is described separately and SHALL be ignored in this section. This field SHALL be ignored if the request body media type is not a multipart. */
  headers: Type.Optional(Type.Record(Type.String(), Type.Union([HeaderObjectRef, reference(HeaderObjectRef)])))
});
export {
  EncodingObjectSchemaDefinition
};
//# sourceMappingURL=encoding.js.map
